define('model/template.state.model',['require','exports','module','formkit/formkit','datakit/datakit'],function(require, exports, module) {
  var FormKit = require('formkit/formkit'),
      DataKit = require('datakit/datakit');

  var TemplateStateModel = FormKit.TemplateModel.extend({
    urlRoot: '/api/v1/document-state/disclosure/validate',

    isValid: function() {
      return this.get('isValid');
    },


    autofillUrl: '/api/v2/coi/disclosure/autofill/:id',

    autofill: function(attrs, options) {
      return BaseModel.prototype.save.call(
        this,
        attrs,
        _.extend(
          {
            url: DataKit.url.template(this.autofillUrl, this, this._urlParams) + '?sfiObjectName=' + this._urlParams.get('sfiObjectName'),
            type: 'POST',
            contentType: 'application/json',
          },
          options
        )
      );
    }
  });

  module.exports = TemplateStateModel;
});

